import React, { useState } from 'react';
import axios from 'axios';
import BrandLogo from '../components/BrandLogo';
import { useWbNavigate } from './WbRouteContext';
import WbShell from './WbShell';
import { setAuthToken } from '../utils/auth';

export default function WbLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useWbNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await axios.post('/api/login', { email, password });
      setAuthToken(res.data.token);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Ошибка входа');
    } finally {
      setLoading(false);
    }
  };

  return (
    <WbShell>
      <div className="min-h-[calc(100vh-40px)] flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <BrandLogo size={56} className="mb-4 shadow-lg" />
            <h1 className="text-2xl font-bold tracking-tight">ТОРГОСЛАВ</h1>
            <p className="text-sm text-[var(--wb-text-muted)] mt-1">
              Аналитика и управление рекламой на Wildberries
            </p>
          </div>

          <div className="wb-card p-8">
            <h2 className="text-lg font-semibold mb-6">Вход в кабинет</h2>
            <form onSubmit={handleLogin} className="space-y-4">
              <div>
                <label htmlFor="wb-login" className="block text-sm font-medium mb-1.5">
                  Логин
                </label>
                <input
                  id="wb-login"
                  type="text"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="username"
                  className="wb-input"
                  placeholder="email или логин"
                />
              </div>
              <div>
                <label htmlFor="wb-password" className="block text-sm font-medium mb-1.5">
                  Пароль
                </label>
                <input
                  id="wb-password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                  className="wb-input"
                  placeholder="••••••••"
                />
              </div>
              {error && (
                <p className="text-sm text-[var(--wb-danger)] bg-[var(--wb-danger-bg)] rounded-lg px-3 py-2" role="alert">
                  {error}
                </p>
              )}
              <button type="submit" disabled={loading} className="wb-btn w-full py-3">
                {loading ? 'Вход...' : 'Войти'}
              </button>
            </form>
          </div>

        </div>
      </div>
    </WbShell>
  );
}
